<template functional>
  <!-- <footer class="the-footer flex-wrap justify-between" :class="classes">-->
  <footer class="ml-5 mt-3 flex-wrap justify-between" :class="classes">
    <p>
      <span>COPYRIGHT &copy;</span>
      <span>{{ new Date().getFullYear() }}</span>
      <a href="https://360photobox.com" target="_blank" rel="nofollow"> 360photobox</a>
      <span class="hidden sm:inline-block">, Tüm Hakları Saklıdır</span>
    </p>
    <!-- <span class="md:flex hidden items-center">
      <span>Hand-crafted & Made with</span>
      <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
    </span>-->
  </footer>
</template>

<script>
/* eslint-disable */
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  }
};
</script>
